import React, { forwardRef } from 'react';
import { Input, Slider, Switch, Wrapper } from './styled';
/**
 * A toggle switch component, use-cases should wrap with a label or
 */
export const Toggle = forwardRef(({ id, className, name, switched, small, onClick = () => { }, disabled, ariaLabel }, ref) => (React.createElement(Wrapper, { className: className, disabled: disabled },
    React.createElement(Switch, { small: small, disabled: disabled, role: "switch" },
        React.createElement(Input, { id: id, type: "checkbox", name: name, "aria-label": ariaLabel, checked: !!switched, onChange: disabled ? undefined : onClick, disabled: disabled, ref: ref }),
        React.createElement(Slider, { switched: switched, disabled: disabled })))));
//# sourceMappingURL=Toggle.js.map